<template>
  <div>
    <div class="h3">Настройки в экстранет выполнены</div>
    <e-alert v-if="activeAccount?.status !== ContractStatus.InProgress" class="paragraph-s_h text-secondary mt-10">
      <div class="text-black paragraph-m_h font-600 mb-1">Дождитесь рассмотрения вашего аккаунта</div>
      <div>
        После перехода аккаунта в статус активен вам будет доступен ID подключения. Используйте этот ID для настройки
        подключения в личном кабинете {{ channelManagerName }}.
      </div>
    </e-alert>

    <div v-else class="paragraph-m_h text-secondary mt-4">
      <div>
        {{
          !isEditMode
            ? 'Укажите ID подключения при добавлении канала продаж в'
            : 'Актуализируйте настройки канала продаж в'
        }}
        <a :href="remoteInteractionUrl || ''" target="_blank" class="link">личном кабинете {{ channelManagerName }}</a>
      </div>

      <property-item class="mt-10" title="ID подключения">
        <div class="d-flex align-center">
          <div>{ {{ interactionId }} }</div>
          <copy-to-clipboard class="ml-2" :text="interactionId || ''" />
        </div>
      </property-item>

      <v-img
        v-if="channelManagerCode === ChannelManagerCode.Bnovo"
        :src="isEditMode ? BnovoConnectionSearch : BnovoConnection"
        class="mt-6"
      />
      <v-img v-else-if="channelManagerCode === ChannelManagerCode.Kontur" :src="KonturConnection" class="mt-6" />
    </div>

    <div class="d-flex justify-space-between mt-10">
      <v-spacer />
      <e-btn variant="secondary" :to="{ name: RouteNames.TariffInfo, params: { t_id: tariffScheduleCID } }">
        Закрыть
      </e-btn>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import { useRoute } from 'vue-router';
import BnovoConnectionSearch from '@/assets/img/pages/tariffs/channel-manager/tutorual-bnovo-search.webp';
import BnovoConnection from '@/assets/img/pages/tariffs/channel-manager/tutorual-bnovo.webp';
import KonturConnection from '@/assets/img/pages/tariffs/channel-manager/tutorual-kontur.webp';
import CopyToClipboard from '@/core/components/buttons/CopyToClipboard.vue';
import PropertyItem from '@/core/components/interface/PropertyItem.vue';
import { EAlert, EBtn } from '@/core/components/ui';
import { RouteNames } from '@/core/plugins/router/routeNames';
import { ChannelManagerCode, ContractStatus } from '@/graphql/generated';
import { useAccommodationObjectsStore } from '@/parts/objects/store/accommodationObjects';
import { useReverseIntegrationStore } from '@/parts/tariffs/store/reverse';

defineProps<{
  isEditMode: boolean;
}>();

const $route = useRoute();

const { activeAccount } = useAccommodationObjectsStore();

const interactionId = toRef(() => $route.query.interactionId?.toString());

const { tariffScheduleCID, remoteInteractionUrl, channelManagerCode } = useReverseIntegrationStore();

const channelManagerName = toRef(() => {
  if (channelManagerCode.value === ChannelManagerCode.Bnovo) {
    return 'Bnovo';
  }

  return 'Контур Отель';
});
</script>
